import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import portfolioScoreService from '../../core/service'

export const getRiskTrend = createAsyncThunk(
  'portfolioInsights/score/riskTrend',
  async (params, { rejectWithValue }) => {
    try {
      const res = await portfolioScoreService.getRiskTrend(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getPerformanceTrend = createAsyncThunk(
  'portfolioInsights/score/performanceTrend',
  async (params, { rejectWithValue }) => {
    try {
      const res = await portfolioScoreService.getPerformanceTrend(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getTrendConfig = createAsyncThunk(
  'portfolioInsights/score/getTrendConfig',
  async (params, { rejectWithValue }) => {
    try {
      const res = await portfolioScoreService.getTrendConfig(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const postTrendConfig = createAsyncThunk(
  'portfolioInsights/score/postTrendConfig',
  async (params, { rejectWithValue }) => {
    try {
      const res = await portfolioScoreService.postTrendConfig(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
